export enum BatteriesConsumables {
  'aa' = 'aa',
  'aaa' = 'aaa',
}
